import React, { useEffect } from "react";
import ModernNavbar from "../components/modern-navbar";
import ModernFooter from "../components/modern-footer";

const Terms = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="modern-landing">
      <ModernNavbar />

      <section className="hero-section">
        <div className="container">
          <div className="hero-content">
            <h1>Terms of Service</h1>
            <p>Please read these terms carefully before using our services.</p>
          </div>
        </div>
      </section>

      <section className="content-section">
        <div className="container">
          <div className="legal-content">
            <h3>Acceptance of Terms</h3>
            <p>
              By accessing and using this service, you accept and agree to be
              bound by the terms and provision of this agreement.
            </p>

            <h3>Use License</h3>
            <p>
              Permission is granted to temporarily use our service for personal,
              non-commercial transitory viewing only.
            </p>

            <h3>Disclaimer</h3>
            <p>
              The materials on our service are provided on an 'as is' basis. We
              make no warranties, expressed or implied.
            </p>

            <h3>Limitations</h3>
            <p>
              In no event shall our company be liable for any damages arising
              out of the use or inability to use our service.
            </p>
          </div>
        </div>
      </section>

      <ModernFooter />
    </div>
  );
};

export default Terms;
